import APIService from './APIService'
import axios from 'axios'

/**
 * Class DeviceService
 * Represents Device services in the api
 * Note: Requires the authentication header in axios
 * */
export default class DeviceService extends APIService{

    /**
     * Constructor
     * Params:
     *  deviceName: String, a device name
     * */
    constructor(deviceName){
        super()
        this.deviceName = deviceName
        this.device_end_point = APIService.API_URL + "/devices/" + this.deviceName
    }

    /**
     * Returns subscriptions of the instance' device
     * */
    getSubscriptions(){
        return axios.get(this.device_end_point + "/subscriptions")
    }

    /**
     * Returns subscribers of the instance' device
     * */
    getSubscribers(){
        return axios.get(this.device_end_point + "/subscribers")
    }

    /**
     * Returns publications of the instance' device
     * */
    getPublications(){
        return axios.get(this.device_end_point + '/publications')
    }

    /**
     * Returns data of the instance' device
     * */
    getData(){
        return axios.get(this.device_end_point)
    }

    /**
     * Sends request for register a new device
     * Params:
     *  data: A JSON array required by the api for register a new device
     * */
    static register(data){
        return axios.post(APIService.API_URL + "/device/register", data)
    }

    /**
     * Sends request for subscribe to a device
     * Params:
     *  data: String, A url of subscription. Format: deviceName?subscriptionCode=code
     * */
    static subscribeTo(data){
        return axios.post(APIService.API_URL + '/device/subscription/' + data)
    }

    /**
     * Sends request for unsubscribe to a device
     * Params:
     *  data: String, A device name
     * */
    static unsubscribeTo(data){
        return axios.delete(APIService.API_URL + '/device/subscription/' + data)
    }

    /**
     * Send device token update request
     * Params:
     *  data: String, new token
     * */
    static updateToken(token) {
        return axios.post(APIService.API_URL + '/me/update-token', {token: token})
    }
}
